import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { secondaryColors } from '@tryhackme/thm-ui-components';

import {
  StyledPlaceholder as Placeholder,
  StyledCopyText as CopyText,
  StyledCopyButton as CopyButton,
  StyledCopyTextWrapper as CopyTextWrapper,
} from 'src/features/management-dashboard/ctf-builder/components/share-ctf-modal/share-ctf-modal.styles';

export const StyledUserPlusIcon = styled(FontAwesomeIcon)`
  && {
    width: 3rem;
    height: 2.4rem;
    margin-right: -0.4rem;
  }
`;

export const StyledFooterButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
    width: 100%;

    & button:first-child {
      order: 1;
    }
  }
`;

export const StyledPlaceholder = styled(Placeholder)<{ $isDarkMode: boolean }>`
  border-radius: ${({ theme }) => theme.radius.small};
  background-color: ${({ $isDarkMode }) => ($isDarkMode ? secondaryColors.black : secondaryColors.grey[100])};
`;

export const StyledCopyText = styled(CopyText)`
  color: ${secondaryColors.grey[800]};
`;

export const StyledCopyButton = styled(CopyButton)<{ $isDarkMode: boolean }>`
  border-radius: ${({ theme }) => theme.radius.small};
  margin-left: 1.2rem;
  background-color: ${({ theme, $isDarkMode }) => ($isDarkMode ? secondaryColors.black : theme.colors.background.main)};
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  width: 16rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.border.light};
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 20rem;
  }
`;

export const StyledButtonIcon = styled(FontAwesomeIcon)`
  && {
    width: 1.4rem;
    height: 1.9rem;
    margin-right: 0.5rem;
  }
`;

export const StyledTextFieldWrapper = styled.div`
  padding: 1.2rem 0 1.2rem;

  & textarea {
    resize: none;
  }
`;

export const StyledCopyTextWrapper = styled(CopyTextWrapper)`
  margin: 1.2rem 0 3rem;
`;
